module.exports = __webpack_public_path__ + "img/r-class.e5760ad1.jpg";